import { IconLayer, GeoJsonLayer } from '@deck.gl/layers';
import { generateSvg, svgToDataUrl } from '../components/NWL/AssetCluster/AssetCluster';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const num = (x) => {
  const n = Number(x);
  return Number.isFinite(n) ? n : undefined;
};

const clusterSizeProps = (pointCount) => {
  const extraSmall = { size: 'extraSmall', iconSize: 48 };
  const small      = { size: 'small',      iconSize: 64 };
  const medium     = { size: 'medium',     iconSize: 72 };
  const large      = { size: 'large',      iconSize: 80 };

  if (pointCount > 10) return large;
  if (pointCount > 6)  return medium;
  if (pointCount > 3)  return small;
  return extraSmall;
};

const classifyByThresholds = (mt) => {
  if (!mt) return 'online';

  const v = num(
    mt?.currentValue ??
      mt?.dataSources?.lastReading?.value ??
      (Array.isArray(mt?.dataSources) ? mt.dataSources[0]?.lastReading?.value : undefined),
  );
  
   // TODO: Revisit when logic is agreed on 
  // if (expired === true) return 'offline';

  const high = mt.thresholds?.high ?? {};
  // const low  = mt.thresholds?.low ?? {};

  const atRiskHigh   = num(mt?.hcritical   ?? high.risk);
  const impactedHigh = num(mt?.hhCritical  ?? high.impacted);
  // const atRiskLow    = num(mt?.lowCritical ?? low.risk);
  // const impactedLow  = num(mt?.llowCritical ?? low.impacted);

  const impacted =
    (impactedHigh != null && v >= impactedHigh)

    // TODO: Revisit when logic is agreed on
    // || (impactedLow  != null && v <  impactedLow);

  if (impacted) return 'impacted';

  const atRisk =
    (atRiskHigh != null && v >= atRiskHigh)
    
    // TODO: Revisit when logic is agreed on
    // || (atRiskLow  != null && v <  atRiskLow);

  if (atRisk) return 'at_risk';

  return 'online';
};

export const generateIconLayer = (layerName, data, zIndex) => {
  const pickLastCoord = (v) => (Array.isArray(v) ? v.at(-1) : v);
  return new IconLayer({
    id: `${layerName}_layer`,
    data,
    getPosition: (d) => [parseFloat(pickLastCoord(d.coordinates).longitude), parseFloat(pickLastCoord(d.coordinates).latitude)],
    getSize: 30,
    getIcon: (d) => ({
      url: d.icon,
      width: 200,
      height: 200,
    }),
    pickable: true,
    zIndex,
  });
};

export const generateGeoJsonIconLayer = (
      layerName, 
      data,
      getClusterChildren, 
      _zIndexIgnored,
      opts = {}
    ) => {

  const { isDefault = false, playTs = null, getPredictedStatus } = opts;
  const initialPieState = {
    online:   { value: 0, fillPattenName: 'onlinePattern', baseColor: '#2BB673',  secondaryColor: '#99EDCF', textColor: '#2A2A27' },
    offline:  { value: 0, fillPattenName: 'offlinePattern', baseColor: '#9194A3', secondaryColor: '#9194A3', textColor: '#2A2A27' },
    impacted: { value: 0, fillPattenName: 'impactedPattern', baseColor: '#DE1E32', secondaryColor: '#DE1E32', textColor: '#FFFFFF' },
    at_risk:   { value: 0, fillPattenName: 'atRiskPattern',  baseColor: '#FFBA5A', secondaryColor: '#FFDDAD', textColor: '#2A2A27' },
  };

  return new GeoJsonLayer({
    id: `${layerName}_layer`,
    data,
    pointType: 'icon',
    getIconSize: (d) => (d.properties.cluster === true
      ? clusterSizeProps(d.properties.point_count).iconSize
      : 48),
    getIcon: (d) => {
      if (d.properties.cluster !== true) {
        return {
          url: d.properties.icon,
          width: 200,
          height: 200,
        };
      }

      const { size } = clusterSizeProps(d.properties.point_count);
      const children = getClusterChildren ? getClusterChildren(d.properties.cluster_id) : [];

      const childData = children.reduce((acc, curr) => {
        const id = curr?.properties?.id ?? '';
        const mt = curr?.properties.measurementTarget || {};

        if (!isDefault) {
					if (getPredictedStatus?.(id) === 'IMPACTED') acc.impacted.value += 1;
					else if (getPredictedStatus?.(id) === 'AT_RISK') acc.at_risk.value += 1;
					else acc.online.value += 1;
        } else {
          const status = classifyByThresholds(mt);
          acc[status].value += 1;
        }
        return acc;
      }, JSON.parse(JSON.stringify(initialPieState)));

      return {
        url: svgToDataUrl(generateSvg({ size, data: childData })),
        width: 200,
        height: 200,
      };
    },
    updateTriggers: {
      getIcon: [isDefault, playTs],
    },
    pickable: true,
    parameters: { depthTest: false },
  });
};